import React from 'react';
import MetricInfoPopover, { MetricInfoDefinition } from '../ui/MetricInfoPopover';
import { getOperationsColumnInfo, getOperationsMetricInfo } from '../../../config/operationsMetricDefinitions';

type OperationsInfoTipProps = {
  metricKey?: string;
  title?: string;
  info?: MetricInfoDefinition;
  columnKey?: string;
  className?: string;
};

/**
 * Info icon — click to toggle tooltip (hover also opens on desktop, same as MetricInfoPopover).
 */
const OperationsInfoTip: React.FC<OperationsInfoTipProps> = ({
  metricKey = '',
  title,
  info,
  columnKey,
  className,
}) => {
  const resolved =
    info ??
    getOperationsMetricInfo(metricKey) ??
    (columnKey ? getOperationsColumnInfo(columnKey) : undefined);

  if (!resolved) return null;

  return (
    <MetricInfoPopover
      title={title ?? metricKey ?? columnKey ?? 'Metric'}
      info={resolved}
      className={className}
    />
  );
};

export default OperationsInfoTip;
